import React from "react";

interface MarkReadIconProps {
  size?: number;
  color?: string;
}

export default function MarkReadIcon({
  size = 20,
  color = "#79808A",
}: MarkReadIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 2.90039C10.4117 2.90039 10.8179 2.99516 11.1846 3.17773L16.6846 5.91602C17.1103 6.12803 17.4678 6.45114 17.7178 6.84863C17.9677 7.24614 18.0996 7.70359 18.0996 8.16992V14.5693C18.0996 15.2412 17.8255 15.8851 17.3379 16.3594C16.8501 16.8337 16.1887 17.0996 15.5 17.0996H4.5C3.81133 17.0996 3.14991 16.8337 2.66211 16.3594C2.17449 15.8851 1.90041 15.2412 1.90039 14.5693V8.16992C1.90038 7.70359 2.03235 7.24614 2.28223 6.84863C2.53216 6.45114 2.88971 6.12803 3.31543 5.91602L8.81543 3.17773C9.18207 2.99516 9.58834 2.90039 10 2.90039ZM3.09961 14.5693C3.09963 14.9287 3.24656 15.2743 3.50879 15.5293C3.77113 15.7843 4.12785 15.9277 4.5 15.9277H15.5C15.8721 15.9277 16.2289 15.7843 16.4912 15.5293C16.7534 15.2743 16.9004 14.9287 16.9004 14.5693V8.59375L10.2783 11.9824C10.1921 12.0266 10.0962 12.05 9.99902 12.0498C9.90181 12.0496 9.80587 12.0259 9.71973 11.9814L3.09961 8.56543V14.5693ZM10 4.07227C9.77752 4.07227 9.55811 4.12316 9.36035 4.22168L3.86133 6.96094C3.6632 7.05961 3.49435 7.20363 3.36523 7.37793L10.001 10.8008L16.6475 7.39844C16.517 7.21548 16.345 7.06338 16.1396 6.96094L10.6396 4.22168C10.4419 4.12316 10.2225 4.07227 10 4.07227Z"
        fill={color}
        stroke={color}
        strokeWidth="0.2"
      />
    </svg>
  );
}
